export const THEME_STORAGE_KEY = "investro-theme";

export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};
